export const unwrap = <T>(value: T | null | undefined): T => {
  if (value === null || value === undefined) {
    throw new Error(`Expected value but got null or undefined`)
  }

  return value
}
